
// Moment.
import moment from 'moment'

export default {
    methods: {
        print() {
            return {
                etiqueta(etiqueta) {

                    const page = window.open('', Math.random())

                    let table = '<table>'

                    etiqueta.listagem.forEach(agendamento => {

                        table = table + `

                            <div class="content">
                                <div class="paper">
                                    <h1>${agendamento.paciente}</h1>
                                    <div class="container">
                                        <div id="header">
                                            <div id="left-col">
                                                <p><strong>DATA NASCIMENTO:</strong> ${agendamento.dataNascimento}</p>
                                                <p><strong>NR. AGENDAMENTO:</strong> ${agendamento.agendamentoNumero}</p>
                                                <p><strong>MÉDICO:</strong> ${agendamento.medicoSolicitante}</p>
                                                <p><strong>DATA EXAME:</strong> ${moment(agendamento.data).format('DD/MM/YYYY')}</p>
                                                <p><strong>EXAMES:</strong>  ${agendamento.exame}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="linha"></div>
                        `
                    })

                    table.concat(`</table>`)

                    page.document.write(`
                        <head>
                            <title>Etiqueta</title>

                            <style>
                                * {
                                    font-family: 'Arial', 'Arial Bold', Gadget, sans-serif;
                                }
                                .content {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                }
                                .paper {
                                    width: 8.3cm;
                                }
                                .container {
                                    display: flex;
                                    flex-direction: column;
                                    padding: 0 0.1cm;
                                }
                                #header {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                #left-col {
                                    flex-grow: 1;
                                    padding-top:5px;
                                }
                                #right-col {
                                    flex-grow: 1;
                                    font-size: 0.3cm;
                                    text-align: right;
                                }
                                h1 {
                                    background-color: #000000;
                                    color: #FFFFFF;
                                    font-size: 0.25cm;
                                    margin: 0;
                                    padding: 0.25cm;
                                    text-align: center;
                                }
                                p {
                                    font-size: 0.25cm;
                                    margin: 0.08cm 0;
                                    padding: 0;
                                }
                                table {
                                    width: 100%;
                                }
                                 table.report-container {
                                    page-break-after: always;
                                }
                                thead.report-header {
                                    display: table-header-group;
                                }
                                tfoot.report-footer {
                                    display: table-footer-group;
                                    border: 0;
                                }
                                table, tbody tr, tbody td {
                                    border: 0;
                                }
                                table {
                                    width: 10.3cm;
                                    border-collapse: collapse;
                                }
                                .linha {
                                    height:10px;
                                }
                            </style>
                        </head>

                        <body>
                            <table class="report-container">
                                <tr>
                                    <td class="report-content-cell" id="table"></td>
                                </tr>
                            </table>
                        </body>
                    `)

                    page.document.getElementById('table').innerHTML = table

                    page.print()
                    page.close()
                },
            }
        }
    },
}